// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Tabs_Tabs__Xdq8T","active":"Tabs_active__3HY9q"};